import { createApp  } from 'vue';
import router from './router';
import store from './store';
import i18n from '../plugins/i18n'
import App from './App.vue';

const rootProps = {
    language: window.currentLanguage,
    baseUrl: window.siteUrl,
    themePath: window.themePath,
}

fetch(process.env.VUE_APP_TRANSLATION_FILE_URL+"?lang="+window.currentLanguage)
    .then(response => response.json())
    .then(data => {
        const app = createApp(App,rootProps);
        app.use(router);
        app.use(store);
        app.use(i18n,data);
        app.mount('#app');
    })
    .catch(error => console.log(error));



